import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

import RouteConstants from './utils/RouteConstants';

import AboutWires from './modules/pages/wires/AboutWires';
import IndrasonWirePage from './modules/pages/wires/IndrasonWirePage';
import AboutFans from './modules/pages/fans/AboutFans';
import OrbitStarPage from './modules/pages/lights/OrbitStarPage';
import AboutProducts from './modules/pages/home/AboutProducts';
import NotFoundPage from './modules/pages/notFound/NotFoundPage';

// TODO(accessories): /accessories is disabled until the page is updated (hero image is a wire
// placeholder, hero "Get Quote" button is unreadable). To re-enable: restore the AboutAccessories
// import + <Route> here, remove "hidden": true from /accessories links in siteChrome.json and the
// home "accessories" card in products.json, re-add /accessories to public/sitemap.xml and
// reactSnap.include in package.json, and delete the /accessories redirect in public/_redirects.
const Routes = () => (
     <Switch>
          <Route exact path={RouteConstants.FANS} component={AboutFans} />
          <Route exact path={RouteConstants.ORBIT_STAR} component={OrbitStarPage} />
          <Route exact path={RouteConstants.INDRASON_WIRE} component={IndrasonWirePage} />
          <Route exact path={RouteConstants.WIRES} component={AboutWires} />
          <Redirect from={RouteConstants.WIRE_COLLECTION} to={RouteConstants.WIRES} />
          <Route path={RouteConstants.ABOUT_PRODUCTS} component={AboutProducts} />
          <Route exact path={RouteConstants.HOME} component={AboutProducts} />
          <Route component={NotFoundPage} />
     </Switch>
);

export default Routes;
